<template>
  <div
    class="service-item"
    @click="$emit('click')"
  >
    <div
      v-if="showIcon"
      class="service-item-image-wrapper"
    >
      <div
        v-if="currentServiceGroup.file && currentServiceGroup.file.file_url"
        class="service-item__image"
        :style="{ backgroundImage: `url(${currentServiceGroup.file.file_url})`}"
      />

      <template v-else>
        <svg
          width="48"
          height="54"
          viewBox="0 0 48 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.6667 11V3.00001C10.6667 2.29277 10.9476 1.61449 11.4477 1.11439C11.9478 0.614295 12.6261 0.333344 13.3333 0.333344H45.3333C46.0406 0.333344 46.7189 0.614295 47.219 1.11439C47.7191 1.61449 48 2.29277 48 3.00001V40.3333C48 41.0406 47.7191 41.7189 47.219 42.219C46.7189 42.7191 46.0406 43 45.3333 43H37.3333V51C37.3333 52.472 36.1333 53.6667 34.648 53.6667H2.68533C2.33367 53.6688 1.98506 53.6014 1.65953 53.4683C1.33399 53.3353 1.03796 53.1393 0.788423 52.8915C0.53889 52.6437 0.340781 52.349 0.205478 52.0244C0.0701749 51.6998 0.000344998 51.3517 0 51L0.00800006 13.6667C0.00800006 12.1947 1.208 11 2.69067 11H10.6667ZM5.33867 16.3333L5.33333 48.3333H32V16.3333H5.33867ZM16 11H37.3333V37.6667H42.6667V5.66668H16V11ZM10.6667 24.3333H26.6667V29.6667H10.6667V24.3333ZM10.6667 35H26.6667V40.3333H10.6667V35Z"
            fill="#3C3C43"
            fill-opacity="0.3"
          />
        </svg>
      </template>
    </div>

    <p
      ref="serviceName"
      class="service-item__name"
      :style="{
        fontSize: serviceNameFontSize,
      }"
    >
      {{ currentServiceGroupName || fallbackTranslationName }}
    </p>

    <svg
      class="service-item__group-open"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5627 16.0001L10.9627 9.4001L12.848 7.51477L21.3334 16.0001L12.848 24.4854L10.9627 22.6001L17.5627 16.0001Z"
        fill="#3C3C43"
        fill-opacity="0.3"
      />
    </svg>
  </div>
</template>

<script>
import ServiceItemMixin from '../mixins/ServiceItemMixin';

export default {
  name: 'ServiceGroup',
  mixins: [ServiceItemMixin],
  computed: {
    currentServiceGroup() {
      return this.$store.groupNames[this.item.group.group_names_id];
    },
    currentServiceGroupName() {
      return this.currentServiceGroup.name[this.$store.currentLanguage.tag];
    },
    fallbackTranslationName() {
      return this.$store.groupNames[this.currentServiceGroup.id].fallbackTranslationName;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/ServiceItem.scss';
</style>